import * as React from 'react';
import { cn } from '@/shared/lib/utils';

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-12 w-full rounded-xl border border-border bg-surface px-4 py-2 text-sm text-text-primary placeholder:text-text-muted transition-all duration-200',
        'focus-visible:outline-none focus-visible:border-primary/40 focus-visible:ring-4 focus-visible:ring-primary/5 focus-visible:bg-surface',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-surface-elevated',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';
